<template>
    <div>
        <div class="top-internal-bar-wrapper">
            <div class="back-arrow" @click="goBack" v-if="!showTopMenu">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18 12.4C18.4971 12.4 18.9 11.9971 18.9 11.5C18.9 11.0029 18.4971 10.6 18 10.6V12.4ZM4.3636 10.8636C4.01213 11.2151 4.01213 11.7849 4.3636 12.1364L10.0912 17.864C10.4426 18.2154 11.0125 18.2154 11.364 17.864C11.7154 17.5125 11.7154 16.9426 11.364 16.5912L6.27279 11.5L11.364 6.40883C11.7154 6.05736 11.7154 5.48751 11.364 5.13604C11.0125 4.78457 10.4426 4.78457 10.0912 5.13604L4.3636 10.8636ZM18 10.6H5V12.4H18V10.6Z" fill="#DA251C"/>
                </svg>
                <span pl-1>Назад</span>
            </div>
            <div v-if="$vuetify.breakpoint.smAndDown">
                <div class="d-flex">
                    <v-img :src="require('@/assets/MapPin.png')" max-width="20" class="mr-1" />
                    <span class="current-city-title">Тюмень</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'TopInternalBar',

        components: {
            //
        },

        computed: {
            showTopMenu() {
                return this.$route.meta?.showTopMenu
            },
        },

        methods: {
            goBack() {
                this.$router.go(-1)
            },
        },
    }
</script>

<style>
    .top-internal-bar-wrapper {
        margin: 30px 0 0px 0;
        border-radius: 10px;
        /* background: #FFF; */
        display: flex;
        align-items: center;
        justify-content: space-between;
        max-width: 1280px;
        width: 100%;
        height: 84px;
    }
    .mobile .top-internal-bar-wrapper {
        margin: 24px 0 0px 0;
        height: 44px;
    }
    .top-internal-bar-wrapper .back-arrow {
        cursor: pointer;
        display: flex;
        align-items: center;
        color: #DA251C;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 140%;
    }
</style>
